import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CategoryWiseStatus,
  DisplayGroup,
  EducationalContentType,
  MilestoneType,
  AdminRoleDesciption,
  UserRoles,
  OptReasons,
  ActiveLanguages,
} from "../../../utility/interfaces/masterDataInterfaces";

interface MasterDataState {
  displayGroups: DisplayGroup[];
  taskTypes: MilestoneType[];
  categoryWiseStatus: CategoryWiseStatus[];
  educationalContentTypes: EducationalContentType[];
  adminRoleDesciption: AdminRoleDesciption[];
  userRoles: UserRoles[];
  optReasons: OptReasons[];
  activeLanguages: ActiveLanguages[];
}

const initialState: MasterDataState = {
  displayGroups: [],
  taskTypes: [],
  categoryWiseStatus: [],
  educationalContentTypes: [],
  adminRoleDesciption: [],
  userRoles: [],
  optReasons: [],
  activeLanguages: [],
};

const adminMasterDataSlice = createSlice({
  name: "adminMasterData",
  initialState,
  reducers: {
    setDisplayGroups(state, action: PayloadAction<DisplayGroup[]>) {
      state.displayGroups = action.payload;
    },
    setTaskTypes(state, action: PayloadAction<MilestoneType[]>) {
      state.taskTypes = action.payload;
    },
    setCategoryWiseStatus(state, action: PayloadAction<CategoryWiseStatus[]>) {
      state.categoryWiseStatus = action.payload;
    },
    setEducationalContentTypes(
      state,
      action: PayloadAction<EducationalContentType[]>
    ) {
      state.educationalContentTypes = action.payload;
    },
    setAdminRoleDesciption(
      state,
      action: PayloadAction<AdminRoleDesciption[]>
    ) {
      state.adminRoleDesciption = action.payload;
    },
    setUserRoles(state, action: PayloadAction<UserRoles[]>) {
      state.userRoles = action.payload;
    },
    setOptReasons(state, action: PayloadAction<OptReasons[]>) {
      state.optReasons = action.payload;
    },
    setActiveLanguages(state, action: PayloadAction<ActiveLanguages[]>) {
      state.activeLanguages = action.payload;
    },
  },
});

export const adminMasterDataActions = adminMasterDataSlice.actions;

export default adminMasterDataSlice.reducer;
